import store from '../store';
import { isPlatformExempt, isTrialFullAccess } from './platformSubscription';
import { hasPlatformModule } from './platformModule';
import { featureSlugs } from './platformEntitlements';

export function hasPlatformFeatureSlug(slug) {
    const subscription = store.state.auth.platformSubscription;

    if (isPlatformExempt() || isTrialFullAccess()) {
        return true;
    }

    const slugs = featureSlugs();

    if (slugs.length === 0) {
        return subscription == null;
    }

    return slugs.includes(slug);
}

/**
 * Checagem por módulo (`agenda`) ou feature (`prontuario.record_templates`).
 * Prefira `hasPlanFeature` em menus e ações de UI.
 */
export function hasPlatformFeature(slug) {
    if (slug.includes('.')) {
        return hasPlatformFeatureSlug(slug);
    }

    return hasPlatformModule(slug);
}

/**
 * Validação de plano no frontend: apenas esconder botões/menus/ações.
 * Permissões de usuário (`hasPermission`) ficam separadas; a API também filtra pelo plano.
 *
 * Módulo inteiro:     hasPlanFeature('agenda') | hasPlanFeature('prontuario') | hasPlanFeature('chat_interno')
 * Feature do plano:   hasPlanFeature('agenda.batch_cancel')
 *                     hasPlanFeature('prontuario.record_templates')
 *                     hasPlanFeature('prontuario.exam_templates')
 */
export function hasPlanFeature(slug) {
    return hasPlatformFeature(slug);
}
